import * as React from 'react'
import ReactTooltip from 'react-tooltip'

import { TmsDataModel } from 'app/models/tmsDataModel'
import { TmsRouteType } from 'app/constants/tmsRouteType'

import { useScene } from '../context/SceneContext'
import { BOTTOM_PADDING } from '../utils/layout'

type TmsDataBlockProps = {
  currentTmsData: TmsDataModel
  index: number
  lane?: number
}

const HEIGHT = 6
const LANE_STEP = HEIGHT + 1

const getZIndex = (tmsRouteType: TmsRouteType): number => {
  let zIndexAddition = 0
  switch (tmsRouteType) {
    case TmsRouteType.CrossTrade:
      zIndexAddition = 1
      break
    case TmsRouteType.CrossTradeBilateral:
    case TmsRouteType.CrossTradeWrong:
      zIndexAddition = 2
      break
    case TmsRouteType.CrossTradeBilateralEmpty:
    case TmsRouteType.CrossTradeWrongEmpty:
      zIndexAddition = 3
      break
    case TmsRouteType.Cabotage:
      zIndexAddition = 4
      break
    case TmsRouteType.CabotageEmpty:
      zIndexAddition = 5
      break
    case TmsRouteType.Transit:
    case TmsRouteType.PolishTransit:
    case TmsRouteType.Domestic:
      zIndexAddition = 6
      break
  }
  return 100 + zIndexAddition
}

export const TmsDataBlock: React.FC<TmsDataBlockProps> = React.memo(
  (props: TmsDataBlockProps) => {
    const scene = useScene()

    const currentTmsData = props.currentTmsData
    const lane = props.lane ?? 0

    const prepareTooltipInfo = (): TmsDataModel => {
      const tmsData = currentTmsData
      return tmsData
    }

    const width = scene.widthOf(
      currentTmsData.displayedLoadingDate,
      currentTmsData.displayedUnloadingDate,
    )
    if (width <= 0) return null

    const position = scene.timeToX(currentTmsData.displayedLoadingDate)
    const routeType = (
      (currentTmsData != null && currentTmsData.routeType != null
        ? TmsRouteType[currentTmsData.routeType]
        : null) ?? TmsRouteType[TmsRouteType.Undefined]
    )
      .toString()
      .toLowerCase()

    const tooltipData = JSON.stringify(prepareTooltipInfo())
    ReactTooltip.rebuild()

    return (
      <div
        className="tw-flex tw-flex-col tw-items-start tw-justify-start"
        style={{
          left: position,
          position: 'absolute',
          bottom: 0,
          height: BOTTOM_PADDING,
        }}
      >
        <div
          className={`tms-marker ${routeType}`}
          data-tip={tooltipData}
          data-for="tmsItemTooltip"
          style={{
            pointerEvents: 'auto',
            height: HEIGHT,
            width: width,
            marginTop: lane * LANE_STEP,
            opacity: 1,
            zIndex: getZIndex(currentTmsData.routeType),
          }}
        />
      </div>
    )
  },
)

TmsDataBlock.displayName = 'TmsDataBlock'
